

(function () {

    angular.module('tmx-common').directive('tmxDonutchart', tmxDonutchart);

    function tmxDonutchart() {

        return {
            scope: {
                data: "=",
                field: "@",
                computed:"@",
                dir: "@",
                type: "@",
                series: "=",
                title: "@",
                categories: "=",
                stack: "@"
            },
            require: 'ngModel',
            restrict: 'E',
            templateUrl: 'common/directives/tmxdonutchart/tmxdonutchart.html',
            controller: tmxDonutchartCtrl,
            controllerAs: 'DonutChartCtrl'

        }
    }
    function tmxDonutchartCtrl($scope, $rootScope,APP_CONSTANTS) {
        $scope.onSeriesHover = function (e) {
            kendoConsole.log(kendo.format("event :: seriesHover ({0} : {1})", e.series.name, e.value));
        };

        var tmxDonutchartVM = this
        tmxDonutchartVM.series = $scope.series;
        tmxDonutchartVM.title = $scope.title;
        tmxDonutchartVM.categories = $scope.categories;
        tmxDonutchartVM.type = $scope.type;
        tmxDonutchartVM.tooltip = "{ visible: 'true', template: '#= series.name #' }"
        tmxDonutchartVM.screenresolution = new kendo.data.DataSource({
            transport: {
                read: {
                    url: APP_CONSTANTS.backend + $scope.data,
                    dataType: "json",
                    beforeSend: function (req) {
                        req.setRequestHeader('Offset', 100);
                    }
                }
            },
            sort: {
                // field: $scope.field,
                // dir: $scope.dir
            }
            
        });

       
        tmxDonutchartVM.chartOptions = /* chart data*/
            {
                // "title": {
                //     "text": tmxDonutchartVM.title,
                //     "position": "bottom"
                // },
                "legend": {
                    "visible": true,
                },
                "seriesDefaults":
                { "type": 'donut', "start-angle": 270 }
                ,

                "series": tmxDonutchartVM.series,

                "dataSource": tmxDonutchartVM.screenresolution,
                "tooltip": {
                    "visible": true,
                    "template": "#= series.field #: #= value # "
                },
                "filter":
                {
                    "field": $scope.field,
                    "operator": "eq"

                },
                "chartArea":
                {
                    "background":"#FFFFFF"
                    // "background": "red"
                }

            }
      
    }

})();